/*
 * handleApiError: Handle API errors, always returning a non-empty string.
 */

const getStringError = (value: unknown): string | undefined => {
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }

  if (value && typeof value === "object") {
    const maybeMessage = (value as { message?: unknown }).message;
    if (typeof maybeMessage === "string" && maybeMessage.trim() !== "") {
      return maybeMessage;
    }
  }

  return undefined;
};

const handleApiError = (error: any): string => {
  if (error.response) {
    console.log(`handleApiError: response status= ${error.response.status ?? "unknown"}`);
    return (
      getStringError(error.response?.data?.message) ??
      getStringError(error.response?.data?.error) ??
      getStringError(error.response?.data?.errorMessage) ??
      getStringError(error.response?.statusText) ??
      getStringError(error.message) ??
      "Unknown error"
    );
  } else {
    console.log("handleApiError: No error response object");
    return getStringError(error.message) ?? "Unknown error";
  }
};

export default handleApiError;
